<style lang="scss" scoped>
@import "@/assets/css/variables.scss";
h4 {
  font-size: 1.2rem;
}
</style>
<template lang="pug">
  FormSection(
    :printOut="printOut"
    title="Basic Information"
    description="The hope of this section is to uncover the ways you spend your time and the experiences you’ve gathered over the years."
  )
    h4 Professional Life
    YesNo(
      name="retired"
      question="Are you currently retired?"
      v-model="user.retired"
      :printOut="printOut"
    )
    .frow(v-if="user.retired")
      .col-md-1-2
        TextInput(
          v-model="user.timeRetired"
          :printOut="printOut"
          example="5 years"
          name="timeRetired"
          question="How long have you been retired?"
        )
      .col-md-1-2
        TextInput(
          v-model="user.work"
          :printOut="printOut"
          example="State Farm"
          name="work"
          question="Where did you work?"
        )
      .col-md-1-2
        TextInput(
          v-model="user.yearsAtLastJob"
          :printOut="printOut"
          example="10 years"
          name="yearsAtLastJob"
          question="How long did you work there?"
        )
      .col-md-1-2
        TextInput(
          v-model="user.occupation"
          :printOut="printOut"
          example="Team Manager"
          name="occupation"
          question="What did you do there?"
        )
    YesNo(
      name="employed"
      question="Are you currently employed?"
      v-model="user.employed"
      :printOut="printOut"
    )
    .frow.width-100(v-if="user.employed")
      .col-md-2-7
        TextInput(
          v-model="user.work"
          :printOut="printOut"
          example="State Farm"
          name="currentWork"
          question="Where do you work?"
        )
      .col-md-3-7
        TextInput(
          v-model="user.yearsAtJob"
          :printOut="printOut"
          example="10 years"
          name="yearsAtJob"
          question="How long have you worked there?"
        )
      .col-md-2-7
        TextInput(
          v-model="user.occupation"
          :printOut="printOut"
          example="Team Manager"
          name="currentOccupation"
          question="What do you do?"
        )
    TextInput(
      v-model="user.occupations"
      :printOut="printOut"
      example="Carpenter/Laborer; Camp Counselor; Hotel Employee; Youth Pastor"
      name="occupations"
      question="What other careers and/or jobs have you had over the years?"
    )
    h4 Additional Affiliations
    TextInput(
      v-model="user.organizations"
      :printOut="printOut"
      example="4 Seasons, Metcalf"
      name="organizations"
      question="What Organizations/Associations/Networks are you currently involved in?"
    )
    TextInput(
      v-model="user.volunteer"
      :printOut="printOut"
      example="Boys/Girls Club, Bloomington Daycare, Home Sweet Home Mission, The Forgotten Initiative, Big Brothers/Big Sisters"
      name="volunteer"
      question="What have you been involved in over the years as a member or volunteer?"
    )
    h4 Hobbies/Interests
    TextInput(
      v-model="user.leisureTime"
      :printOut="printOut"
      example="Reading, Lifting Weights, Runs and Walks, Yoga, Ice Cream, Movies, Breweries"
      name="leisureTime"
      question="What do you enjoy doing with leisure time?"
    )
    TextInput(
      v-model="user.passions"
      :printOut="printOut"
      example="Communication, Leadership, Next Generation, Community Betterment"
      name="passions"
      question="Is there anything that you’re particularly gifted in or passionate about?"
    )
    TextInput(
      v-model="user.sideHustle"
      :printOut="printOut"
      example="Spiritual Formation through the Enneagram"
      name="sideHustle"
      question="Do you have a 'side hustle' of some sort?"
    )
</template>
<script>
import FormSection from "@/new-components/GuideForm/FormSection";
import YesNo from "@/new-components/GuideForm/YesNo";
import TextInput from "@/new-components/GuideForm/TextInput";
export default {
  name: "basic-information",
  components: {
    FormSection,
    YesNo,
    TextInput
  },
  props: {
    user: {
      type: Object
    },
    printOut: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({})
};
</script>
